import React, { useContext } from "react";
import './index.scss';
import Button from "../Buttons/Button";
import Context from "../../../context";
import ModalDefault from "../Modal/ModalDefault";
import MyDocumentManager from "./MyDocumentManager";

const MyDocumentsUploadPanel = ({ fileInputRef, getFiles, onFileSelect, isUploadOpen, onCancel, handleFileUpload, isRetry, uploadDocConfig, setUploadDocConfig, showUploadHint }) => {
  const { viewMode, itin, t } = useContext(Context);

  return (
    <>
      <div className="upload-hint-container">
        {showUploadHint && (
          viewMode === 'desktop' ? (
            <>
              <p>{t('upload_documents_instructions_desktop', { lng: itin.language })}</p>
            </>
          ) : (
            <>
              <p dangerouslySetInnerHTML={{ __html: t('upload_documents_instructions', { lng: itin.language }).replace(/\n/g, '<br />') }} />
            </>
          )
        )}

        {viewMode === 'desktop' && <Button onClick={() => getFiles()}>{t("upload", { lng: itin.language })}</Button>}

        <input
          type="file"
          accept="image/jpeg, image/jpg, image/png, image/webp, image/heic, image/heif, video/mp4, application/pdf, text/html"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={onFileSelect}
        />
      </div>

      <ModalDefault
        isOpen={isUploadOpen}
        className="modal-global"
        header={t('document_settings_add_document', { lng: itin.language })}
        buttons={[
          <button key={0} onClick={onCancel}>{t('cancel', { lng: itin.language })}</button>,
          <button key={1} onClick={handleFileUpload}>{t('confirm', { lng: itin.language })}</button>
        ]}
      >
        <MyDocumentManager document={null} uploadDocConfig={uploadDocConfig} setUploadDocConfig={setUploadDocConfig} />
      </ModalDefault>
    </>
  );
};

export default MyDocumentsUploadPanel;